<template>
    <v-card outlined elevation="4" style="border-radius: 1px; border: 1px solid #DADADA; padding: 5px 0px;">


        <v-flex style="display: flex; padding: 20px;">

            <v-avatar size="160" class="mr-3">
                <img src="https://plus.unsplash.com/premium_photo-1661270419594-b6923ac9856a?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    alt="Profile" style="object-fit: cover; width: 100%; height: 100%;" />
            </v-avatar>


            <v-flex style="display: flex; flex-direction: column; align-items: flex-start; gap: 5px; padding: 40px;">
                <div class="text-h6 font-weight-medium">
                    <v-span style="font-weight: 600; color:blue; font-size: 40px;">
                        Kulpreet jr.
                    </v-span>
                </div>


                <div style="display: flex; gap: 10px; font-size: 20px;">
                    <span class="text-body-2 grey--text">Canada</span>
                    |
                    <span class="text-body-2 grey--text">Age: 28</span>
                </div>
            </v-flex>



        </v-flex>


        <v-flex style="display: flex; gap: 40px;  padding: 20px 30px;">
            <span style="font-size: 20px;" class="text-body-2 font-weight-medium">Looking for <br> Hourly rate</span>
            <span style="font-size: 20px;" class="text-body-2 font-weight-bold">Casual <br> $35</span>
        </v-flex>

        <v-flex style="padding: 20px; opacity: 0.7;">
            <v-flex style="display: flex; justify-content: space-between; gap: 20px; padding: 10px 20px; ">
                <app-svg-icon :style="{ fill: highlightedIcons.includes(icon) ? 'blue' : 'gray' }"
                    v-for="(icon, i) in rowOneIcons" :key="i" :name="`brand/${icon}`" width="40" height="40" />
            </v-flex>

            <v-flex
                style="display: flex; justify-content: space-between; flex-wrap: wrap; gap: 20px; padding: 10px 20px; ">
                <app-svg-icon :style="{ fill: highlightedIcons.includes(icon) ? 'blue' : 'gray' }"
                    v-for="(icon, i) in rowTwoIcons" :key="i" :name="`brand/${icon}`" width="40" height="40" />
            </v-flex>
        </v-flex>

        <!-- card footer -->
        <v-flex style="border-top:1px solid #ddd; padding: 20px 15px;" wrap>
            <v-flex :class="{ 'xs12 d-flex px-3': true, 'md12': !grid }">
                <div class="_actions--items"
                    style="display: flex; justify-content: space-between; align-items: center; gap: 4px;">

                    <app-btn-chat-room style="font-size: 20px; display: flex; align-items: center;"
                        class="d-link d-inline ma-0 d-link--contact pl-0 text-xs-left" flat>
                        <app-svg-icon height="20px" style="margin-bottom: 5px;" width="20px"
                            name="brand/NG_CONTACT"></app-svg-icon>
                        <span style="font-weight: 600; ">Apply</span>
                    </app-btn-chat-room>


                    <app-btn-chat-room style="font-size: 20px; display: flex; align-items: center;"
                        class="d-link d-inline ma-0 d-link--contact pl-0 text-xs-left" flat>
                        <app-svg-icon height="20px" style="margin-bottom: 5px;" width="20px"
                            name="brand/NG_FAVOURITES"></app-svg-icon>
                        <span style="font-weight: 600; ">Shortlist</span>
                    </app-btn-chat-room>
                    <app-btn-chat-room style="font-size: 20px; display: flex; align-items: center;"
                        class="d-link d-inline ma-0 d-link--contact pl-0 text-xs-left" flat>
                        <app-svg-icon height="20px" style="margin-bottom: 5px;" width="20px"
                            name="brand/NG_INBOX"></app-svg-icon>
                        <span style="font-weight: 600; ">Recommend</span>
                    </app-btn-chat-room>

                </div>
            </v-flex>

        </v-flex>
    </v-card>
</template>


<script>
import AppBtnToggleCaregiver from '../../../components/app-buttons/app-btn-toggle-caregiver.vue';

export default {
    name: 'recommended-nanny-main-card',
    components: {
        AppBtnToggleCaregiver,
    },
    data() {
        return {
            rowOneIcons: [
                "NG_NON_SMOKER",
                "NG_FIRST_AID",
                "NG_POLICE_CHECK",
                "NG_HAS_CAR",
                "NG_COOKING_BAKING"
            ],
            rowTwoIcons: [
                "NG_HOUSEHOLD_CLEANING",
                "NG_CHILDCARE_QUAL",
                "NG_HOMEWORK_SUPPORT",
                "NG_RELIABLE",
                "NG_PARENT_REFERENCE",
                "NG_PETS",
                "NG_ONLINE_SAFETY",
                "NG_MEAL_PREP",
                "NG_LOVING"
            ],
            highlightedIcons: ["NG_NON_SMOKER", "NG_COOKING_BAKING"],
        };
    }
}


</script>


// WEBPACK FOOTER //
// src/views/app/recommendednanny/recommended-nanny-main-card.vue